import React, { useRef } from "react";
import { Tooltip, useIsOverflowing } from "@sscs/ui";
import styles from "./groupListTooltip.module.scss";

type TooltipContentProps = {
  groups: string[];
};

const TooltipContent = ({ groups }: TooltipContentProps): React.JSX.Element => {
  return (
    <>
      {groups.map((group) => (
        <div key={group}>{group}</div>
      ))}
    </>
  );
};

type GroupListTooltipProps = {
  groups: string[];
};

const GroupListTooltip = ({
  groups,
}: GroupListTooltipProps): React.JSX.Element => {
  const ref = useRef<HTMLDivElement>(null);
  const overflow = useIsOverflowing(ref);

  return groups.length === 0 ? (
    <>--</>
  ) : (
    <Tooltip title={overflow ? <TooltipContent groups={groups} /> : ""}>
      <div ref={ref} className={styles.groups}>
        {groups.join(", ")}
      </div>
    </Tooltip>
  );
};

export default GroupListTooltip;
